import { isValidURL } from 'ui-components';
import type * as clientApiViewModel from '~/clientApi';
import { SOCIAL_PLATFORM_PIPELINE_STATUS } from '~/clientApi/offPlatform.model';
import { PlatformType } from '~/screens/ManagePlatforms/common';

export type ConnectedPlatformsType = {
  platform: string;
  name: string | undefined;
  handle: string | undefined;
  count: number | undefined;
  status: string | undefined;
};

export const getConnectedPlatforms = (
  platforms: clientApiViewModel.CreatorPlatformsType,
  isOffPlatform: boolean | undefined,
): ConnectedPlatformsType[] =>
  Object.entries(platforms)
    .filter(
      ([_, platform]) =>
        platform.isConnected ||
        (isOffPlatform && platform.followersCount) ||
        platform.status === 'manual' ||
        platform.status === 'off-platform' ||
        platform.status === 'disconnected' ||
        platform.status === 'connected',
    )
    .map(
      ([
        platform,
        { handle, followersCount, name, status, subscriberCount },
      ]) => ({
        platform,
        name,
        handle,
        count: followersCount || subscriberCount,
        status,
      }),
    );

export const filterPlatformsByStatus = (
  platform: PlatformType,
  status: SOCIAL_PLATFORM_PIPELINE_STATUS,
) => {
  if (!platform) return [];

  return Object.entries(platform).filter(
    ([_key, value]) => value.pipelineStatus === status,
  );
};

// Very basic function to remove @ symbol from the beginning of the handle
export const parseHandle = (handle?: string, FFEnabled?: boolean) => {
  if (!handle) return undefined;
  const trimmedHandle = handle.trim().toLowerCase();
  if (trimmedHandle.startsWith('@')) {
    return trimmedHandle.substring(1);
  }
  // we need to parse the handle from the URL for checking if the handle is duplicated
  if (isValidURL(handle.trim()) && FFEnabled) {
    const segments = trimmedHandle.split('/');
    const lastSegment = segments[segments.length - 1];
    return lastSegment.substring(1) || trimmedHandle.substring(1);
  }
  return trimmedHandle;
};
